// JobTitleTab.js
import { Grid, Typography, Box, Button, TextField, InputAdornment } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { toast, ToastContainer } from "react-toastify";
import JobTitleDialog from "screens/Employees/component/Jobtitle";
import { useJobTitleLogic } from "../logic/JobTitleTablogic";

const JobTitleTab = () => {
  const { JobTitleProps } = useJobTitleLogic(toast);

  const {
    handleOpenJobTitleDlg,
    columns,
    paginationModel,
    setPaginationModel,
    openJobTitleDlg,
    handleCloseJobTitleDlg,
    rows,
    loading,
    searchQuery,
    handleSearchChange,
    filteredRows,
  } = JobTitleProps;

  return (
    <>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", lg: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", lg: "center" },
              gap: { xs: 2, lg: 0 },
            }}
          >
            <Box>
              <Typography variant="h3">Job Titles</Typography>
              <Typography color="secondary">
                Manage your desired Job Titles in the system.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
              <TextField
                placeholder="Search job titles..."
                value={searchQuery}
                onChange={handleSearchChange}
                size="small"
                sx={{
                  width: { xs: "100%", sm: 300 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="contained"
                color="main"
                startIcon={<AddIcon />}
                onClick={handleOpenJobTitleDlg}
                sx={{
                  whiteSpace: 'nowrap'
                }}
              >
                Create Job Title
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <DataGridPro
            rows={filteredRows || rows || []}
            rowHeight={62}
            columns={columns || []}
            disableRowSelectionOnClick
            sx={{
              minHeight: 280,
              maxHeight: 600,
              "& .MuiDataGrid-columnHeaderTitle": {
                textTransform: "none",
              },
            }}
            slots={{
              footer: () => null
            }}
            loading={loading}
          />
        </Grid>
      </Grid>

      {/* <ToastContainer /> */}

      <JobTitleDialog
        open={openJobTitleDlg}
        handleClose={handleCloseJobTitleDlg}
        JobTitleProps={JobTitleProps}
      />
    </>
  );
};

export default JobTitleTab;